export default __webpack_public_path__ + "static/media/cube45.ebf0165e.png";